import { useState } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Plus, Mail, Phone } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { listProfessionals } from "@/lib/api/professionals";
import { ProfessionalDialog } from "@/components/professional-dialog";

export const Route = createFileRoute("/profesionales/")({
  head: () => ({
    meta: [
      { title: "Profesionales · Rafael González" },
      { name: "description", content: "Listado de profesionales sanitarios de la clínica." },
    ],
  }),
  component: ProfessionalsPage,
});

function ProfessionalsPage() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { data: professionals = [], isLoading } = useQuery({
    queryKey: ["professionals"],
    queryFn: () => listProfessionals(),
  });

  return (
    <div className="mx-auto max-w-6xl space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Profesionales</h1>
          <p className="text-sm text-muted-foreground">Equipo de la clínica.</p>
        </div>
        <Button onClick={() => setDialogOpen(true)}>
          <Plus className="mr-2 h-4 w-4" /> Nuevo profesional
        </Button>
      </div>

      {isLoading ? (
        <p className="text-muted-foreground">Cargando...</p>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {professionals.map((p) => (
            <Link key={p.id} to="/profesionales/$id" params={{ id: p.id }} className="block">
              <Card className="transition-shadow hover:shadow-md">
                <CardHeader className="flex flex-row items-center gap-3 space-y-0">
                  <Avatar>
                    <AvatarFallback style={{ backgroundColor: p.color, color: "white" }}>
                      {p.firstName[0]}{p.lastName[0]}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <CardTitle className="text-base">{p.firstName} {p.lastName}</CardTitle>
                    <p className="text-xs text-muted-foreground">{p.specialty}</p>
                  </div>
                </CardHeader>
                <CardContent className="space-y-1 text-sm text-muted-foreground">
                  <div className="flex items-center gap-2"><Mail className="h-3.5 w-3.5" /> {p.email}</div>
                  <div className="flex items-center gap-2"><Phone className="h-3.5 w-3.5" /> {p.phone}</div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}

      <ProfessionalDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </div>
  );
}
